import React, { useContext, useEffect, useRef } from "react";
import "./InvoicePrint.css";
import "firebase/compat/firestore";
import { DataContext } from "../Context/DataContext";
import { formatTotal, getDiscount, getExpedited, getHardCopyPrice, getTotal, signaturePrice } from "../Data/Functions";
import {ReactComponent as EVERBARY_LOGO} from "../assets/icons/everbary-logo-black.svg";
import { useReactToPrint } from "react-to-print";

export const QuoteSummaryToPrint = ({quoteInfo, setDownloadQuote, downloadQuote, setShowBtns = () => {}}) => {

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };

  const ref = useRef();

  const handlePrint = useReactToPrint({
      content: () => ref.current,
      documentTitle: `Quote ${quoteInfo.quoteNumber}`,
  });

  useEffect(() => {
    if(quoteInfo && downloadQuote=== quoteInfo.id){
        handlePrint()
        setDownloadQuote("");
    }
  }, 
  [downloadQuote, quoteInfo]);

  if (!quoteInfo) {
    return <div>Loading,Please wait<span className="loadingDots">...</span></div>;
  }else{ 
    setShowBtns(true)
  }

  return (
      <div
        ref={ref}
        className={`bg-[#f6f6f6] font-sans antialiased text-sm leading-relaxed h-dvh  mx-auto py-8 px-12 flex flex-col justify-between h-full`}
      >
        <table
          border="0"
          cellPadding="0"
          cellSpacing="0"
          className="border-separate w-full "
        >
          <tr>
            <td className="font-sans text-sm align-top block mx-auto mb-4  p-2.5">
              <div className="box-border block mx-auto p-2.5">
                <EVERBARY_LOGO/>
              </div>
            </td>
          </tr>
          <tr>
            <table class="w-full border-collapse">
              <tr>
                <td class="w-1/2 align-top p-4">
                  <h2 class="text-[14px] font-bold text-[#1eb8bc]">
                    Quote:
                  </h2>
                  <p class="text-[14px] font-normal text-[#2d2d2d] my-2 tracking-tight leading-[13px]">
                    {quoteInfo.name}
                  </p>
                  <p class="text-[12px] font-normal text-[#969696] tracking-tight leading-[13px]">
                    {quoteInfo.email}
                  </p>
                </td>
                <td class="w-1/2 align-top p-4 text-left">
                  <h2 class="text-[14px] font-bold text-[#1eb8bc] mb-0">
                    Quote
                  </h2>
                  <p class="flex justify-between border-b border-[#e0e0e0] mt-2 pb-2">
                    <strong class="text-[12px] text-[#2d2d2d]">
                      Language Pair:
                    </strong>

                    <span className="text-[12px] leading-[14px] tracking-[-0.04em] text-[#2d2d2d] font-normal not-italic flex items-center gap-2 capitalize">
                      {quoteInfo.languageFrom}
                      <img src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2FRight-Arrow.svg?alt=media&token=b83172e4-5e99-4f72-a735-0f774bf79859" alt="" />
                      {quoteInfo.languageTo}
                    </span>
                  </p>
                  <p class="flex justify-between mt-0 py-2">
                    <strong class="text-[12px] text-[#2d2d2d]">Date:</strong>
                    <span class="text-[12px] text-[#2d2d2d]">
                      {formatDate(quoteInfo.timestamp)}
                    </span>
                  </p>
                </td>
              </tr>
            </table>
          </tr>

          <tr>
            <div class="p-4 bg-[#fafafa] shadow-lg rounded-2xl my-12 w-full">
              <table class="w-full border-collapse rounded-2xl">
                <thead class="p-4">
                  <tr>
                    <th class="invoiceHeader">Description</th>
                    <th class="invoiceHeader">Qty.</th>
                    <th class="pb-2 border-b border-[#e0e0e0]"></th>
                    <th class="invoiceHeader">Unit Price</th>
                    <th class="invoiceHeader">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="invoiceItem">Certified Translation</td>
                    <td class="invoiceItem">
                      {quoteInfo.pagesCount ? parseInt(quoteInfo.pagesCount, 10) + (quoteInfo.pagesCount === "1" ? " page" :" pages") : "In Review"}
                    </td>
                    <td className="invoiceItem"></td>
                    <td class="invoiceItem">$24.95</td>
                    <td class="invoiceItem">
                      {quoteInfo.pagesCount ? ("$" + parseInt(quoteInfo.pagesCount, 10) * 24.95) : "In Review"}
                    </td>
                  </tr>

                  {(quoteInfo.expeditedPlus || quoteInfo.expedited) && (
                    <tr>
                      <td class="invoiceItem">
                        Expedited Turnaround{" "}
                        {quoteInfo.expeditedPlus ? "Plus" : ""}
                      </td>
                      <td class="invoiceItem">
                        {" "}
                        {quoteInfo.pagesCount ? parseInt(quoteInfo.pagesCount, 10) + (quoteInfo.pagesCount === "1" ? " page" :" pages")  :"In Review"}
                      </td>
                      <td className="invoiceItem"></td>
                      <td class="invoiceItem">
                        {quoteInfo.expeditedPlus ? "$9.98" : "$4.99"}
                      </td>
                      <td class="invoiceItem">{quoteInfo.pagesCount ? "$" + getExpedited(quoteInfo) : "In Review"}</td>
                    </tr>
                  )}

                  {quoteInfo.notarization && (
                    <tr>
                      <td class="invoiceItem">Notarization</td>
                      <td class="invoiceItem">1</td>
                      <td className="invoiceItem"></td>
                      <td class="invoiceItem">$34.90</td>
                      <td class="invoiceItem">
                        {quoteInfo.pagesCount ? quoteInfo.notarization ? "$34.90" : "0" : "In Review"}
                      </td>
                    </tr>
                  )}

                  {quoteInfo.hardCopy &&
                    quoteInfo.hardCopyExtra.country !== "" &&
                    quoteInfo.hardCopyExtra.method !== "" && (
                      <tr>
                        <td class="invoiceItem">{`USPS ${
                          quoteInfo.hardCopyExtra.method
                            .charAt(0)
                            .toUpperCase() +
                          quoteInfo.hardCopyExtra.method.slice(1)
                        } Mail ${
                          ![
                            "United States",
                            "Puerto Rico",
                            "U.S. Virgin Islands",
                          ].includes(quoteInfo.hardCopyExtra.country)
                            ? "International"
                            : ""
                        }`}</td>
                        <td class="invoiceItem"> 1 </td>
                        <td className="invoiceItem"></td>
                        <td class="invoiceItem">
                          {quoteInfo.pagesCount ? "$" + getHardCopyPrice(
                            quoteInfo.hardCopyExtra.country,
                            quoteInfo.hardCopyExtra.method,
                            false,
                            quoteInfo
                          ) : "In Review"}
                        </td>
                        <td class="invoiceItem">
                          {quoteInfo.pagesCount ? "$" + getHardCopyPrice(
                            quoteInfo.hardCopyExtra.country,
                            quoteInfo.hardCopyExtra.method,
                            false,
                            quoteInfo
                          ) : "In Review"}
                        </td>
                      </tr>
                    )}

                  {quoteInfo.hardCopy &&
                    quoteInfo.hardCopyExtra.requireSignature && (
                      <tr>
                        <td class="invoiceItem">
                          Signature Required for Delivery
                        </td>
                        <td class="invoiceItem">1</td>
                        <td className="invoiceItem"></td>
                        <td class="invoiceItem">$4.99</td>
                        <td class="invoiceItem">
                          {quoteInfo.pagesCount ? quoteInfo.hardCopy &&
                          quoteInfo.hardCopyExtra.requireSignature
                            ? `$${signaturePrice(true, quoteInfo)}`
                            : 0 : "In Review"}
                        </td>
                      </tr>
                    )}

                  <tr>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-[#575757] invoiceItem">
                      Subtotal
                    </td>
                    <td class="invoiceItem"></td>
                    <td class="invoiceItem">{quoteInfo.pagesCount ? formatTotal(getTotal(quoteInfo)) : "In Review"}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-[#575757] invoiceItem">
                      Discount
                    </td>
                    <td class="invoiceItem"></td>
                    <td class="invoiceItem">{quoteInfo.pagesCount ? ("-" + formatTotal(getDiscount(quoteInfo))) : "In Review"}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td class="invoiceHeader !border-none py-2">Total</td>
                    <td></td>
                    <td class="invoiceHeader !border-none py-2">{quoteInfo.pagesCount ? formatTotal(getTotal(quoteInfo) - getDiscount(quoteInfo))  : "In Review"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </tr>
        </table>

        <table className="w-full flex flex-col gap-8 justify-center items-center">
          {quoteInfo.discount > 0 && (
            <tr>
              <td className="w-full">
                <div className="mx-auto border-b border-[#e0e0e0] w-fit py-[0.8rem]">
                  <h2 class="heading">Important Note</h2>
                  <p class="description">
                    A {quoteInfo.discount}% discount has been applied as part of
                    our ongoing cooperation.
                  </p>
                </div>
              </td>
            </tr>
          )}

          <tr>
            <td className="w-full">
              <div className="mx-auto border-b border-[#e0e0e0] w-fit py-[0.8rem]">
                <h2 class="heading">Need it sooner?</h2>
                <p class="description">
                  Let us know—we’ll offer options to meet your deadline
                </p>
              </div>
            </td>
          </tr>

          <tr>
            <td className="w-full">
              <div className="mx-auto mb-12 w-fit">
                <p class="description">
                  For questions, chat with us in the
                  <span class="heading"> Quote Chat </span>
                </p>
              </div>
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td class="mx-auto mb-8">
              <h1 class="text-center text-2xl font-semibold text-[#1eb8bc]">
                Thank you for choosing <span class="font-black">eVerbary!</span>
              </h1>
            </td>
          </tr>

          <tr>
            <td className="h-8"></td>
          </tr>
          <tr>
            <table class="w-full">
              <tr class="w-full flex justify-between">
                <td class="p-4">
                  <div class="flex items-center gap-2">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2Fcall.svg?alt=media&token=715ea837-eec5-4faf-a7f8-1642c2fab565"
                      alt="call"
                      class="w-[18px] h-[18px]"
                    />
                    <span class="text-[14px] font-normal text-[#2d2d2d]">
                      +1 (505) 916-8399
                    </span>
                  </div>
                </td>
                <td class="p-4">
                  <div class="flex items-center gap-2">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2FblueEnvelop.svg?alt=media&token=adbff61f-4224-4292-808f-50acafd135da"
                      alt="email"
                      class="w-[18px] h-[18px]"
                    />
                    <span class="text-[14px] font-normal text-[#2d2d2d]">
                      support@everbary.com
                    </span>
                  </div>
                </td>
                <td class="p-4">
                  <div class="flex items-start gap-2">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2Flocation.svg?alt=media&token=e991ba05-61a5-4e4e-94ec-09fd591bdb88"
                      alt="location"
                      class="w-[18px] h-[18px] mt-1"
                    />
                    <span class="text-[14px] font-normal text-[#2d2d2d] leading-[1.4]">
                      1209 Mountain Road Pl NE Ste N <br />
                      Albuquerque, NM 87110 <br />
                      United States
                    </span>
                  </div>
                </td>
              </tr>
            </table>
          </tr>
        </table>
      </div>
  );
};
